import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UtilitiesService } from '../../common/shared/services/utilities.service';

@Injectable({
  providedIn: 'root'
})
export class TermsService {

  constructor(private _httpClient: HttpClient, private _utilitiesService: UtilitiesService) { }

  public loadCurrentTerms() {
    return this._httpClient.get(this._utilitiesService.getAPIUrl() + 'Terms/Current', this._utilitiesService.httpConfig);
  }

  public createConsent() {
    return this._httpClient.put(this._utilitiesService.getAPIUrl() + 'Terms/Consent', this._utilitiesService.httpConfig);
  }

  public hasValidConsent() {
    return this._httpClient.get(this._utilitiesService.getAPIUrl() + 'Terms/Consent/Valid', this._utilitiesService.httpConfig);
  }
}
